<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-select
        v-model="controller"
        :items="controllerItems"
        :label="label"
        persistent-hint
        hide-selected
        hide-details
        @input="changeItems"
    >
    </v-select>
    <v-select
        v-model="action"
        :items="actions"
        :label="label"
        persistent-hint
        hide-selected
        hide-details
        @input="changeItems"
    >
    </v-select>
    <v-select
        v-model="messageId"
        :items="messages"
        label="Сообщение"
        item-text="title"
        item-value="id"
        persistent-hint
        hide-selected
        hide-details
        @input="changeItems"
    >
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageConstants from '../message/messageConstants'

export default {
    name: 'ModuleSelect',
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    data() {
        return {
            controller: null,
            action: null,
            value: null,
            messageId: null
        }
    },
    methods: {
        loadItems() {
            this.selectedItems = []
            if (this.params.loadValues === 'mailing_group') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.getMailingGroupById(this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push({ value: item.id, title: item.title })
                    }
                }
            }
            if (this.params.loadValues === 'messages') {
                this.selectedItem = this.modelItems
            }
            if (this.params.loadValues === 'variables') {
                this.selectedItem = this.modelItems
            }
            if (this.params.loadValues === 'cardLists') {
                this.selectedItem = this.modelItems
            }
            if (this.params.loadValues === 'action') {

            }
            if (this.modelItems) {
                let items = this.modelItems[0].split('.')
                this.controller = items[0]
                this.action = items[1]
                if (this.modelItems.length > 0) {
                    this.messageId = this.modelItems[1]
                }
            }
        },
        removeItem(index) {
            this.selectedItems.splice(index, 1)
            this.changeItems()
        },
        changeItems() {
            console.log([this.controller + '.' + this.action])
            this.$emit('updateItems', {
                items: [this.controller + '.' + this.action, this.messageId],
                methodId: this.methodId,
                index: this.index,
                indexCell: this.indexCell
            })
        }
    },
    computed: {
        ...mapGetters({
            messages: 'messages/messages'
        }),
        controllerItems() {
            return messageConstants.controllerItems.filter(controller => controller.value !== 'variable')
        },
        actions() {
            return this.controller === '' ? [] : messageConstants.actions[this.controller]
        }
    },
    watch: {
        load(value) {
            if (value) {
                this.loadItems()
            }
        }
    },
    mounted() {
        this.loadItems() // первоначальная загрузка, потому что watch не срабатывает
    }
}
</script>

<style scoped>

</style>
